import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface NavigationState {
  page: number;
  tab?: number;
  filters?: any[];
}

const navigationStateKey = 'navigationState';

export const useNavigationState = () => {
  const location = useLocation();
  const [state, setState] = useState<NavigationState>({ page: 0 });

  // Load state from localStorage on mount
  useEffect(() => {
    const savedState = localStorage.getItem(`${navigationStateKey}_${location.pathname}`);
    if (savedState) {
      try {
        const parsedState = JSON.parse(savedState);
        setState(parsedState);
      } catch (error) {
        console.error('Failed to parse navigation state:', error);
      }
    }
  }, [location.pathname]);

  // Save state to localStorage whenever it changes
  const updateState = (newState: Partial<NavigationState>) => {
    const updatedState = { ...state, ...newState };
    setState(updatedState);
    localStorage.setItem(`${navigationStateKey}_${location.pathname}`, JSON.stringify(updatedState));
  };

  // Clear state (useful when navigating away)
  const clearState = () => {
    setState({ page: 0 });
    localStorage.removeItem(`${navigationStateKey}_${location.pathname}`);
  };

  return {
    state,
    updateState,
    clearState,
  };
};
